// i18n for the /campaigns/post-social-and-earn-bluebreads page
// Languages: en, vi, ja, zh, ko

export const campaignTranslations = {
  en: {
    nav: {
      howItWorks: "How it works",
      rules: "Rules",
      rewards: "Rewards",
      submit: "Submit",
    },
    hero: {
      seasonBadge: "Season 01 · Spring 2026",
      rewardsLive: "Rewards live now",
      h1Line1: "From a tiny",
      h1Matchstick: "matchstick",
      h1Line2Pre: "to an",
      h1Immortal: "immortal",
      h1Line2Post: "sun.",
      descPre: "Light the fuse on your content. Post PHUONG on TikTok or anime Facebook groups, hit the engagement threshold, and we'll drop",
      descBluebreads: "Bluebreads",
      descAnd: "— and possibly",
      descPro: "PRO Membership",
      descTail: "— into your in-app mailbox within 48 hours.",
      ctaPrimary: "Start Earning Bluebreads",
      ctaSecondary: "How it works",
      statMin: "Min. Bluebreads",
      statPayout: "Payout window",
      statMax: "Max potential",
      bluebreadDrop: "+100 Bluebread",
    },
    how: {
      label: "The Loop",
      headPre: "Five steps from",
      headMid: "spark",
      headTail: "to payout.",
      subcopy: "A clean loop you can run once, run daily, or run in your sleep. The more you post, the more immortal the sun.",
      steps: [
        { title: "Create content", body: "Film, edit, design — original TikTok videos or Facebook posts featuring your real PHUONG experience." },
        { title: "Post & tag", body: "Publish on TikTok or anime Facebook groups / your public profile. No reposts. No mirrors. Originals only." },
        { title: "Hit the threshold", body: "TikTok: 100+ views. Facebook: 10+ reactions. Quality content often blows past this on day one." },
        { title: "Submit the link", body: "Drop the public URL and your PHUONG account email into the form on this page." },
        { title: "Receive rewards", body: "Within 48h we'll verify and drop Bluebreads into your in-app mailbox. Big hits earn PRO Membership." },
      ],
      next: "Next ↓",
      done: "Done ✓",
    },
    rules: {
      label: "Eligibility",
      headPre: "The",
      headTail: "rules of the arena.",
      subcopy: "Simple, strict, fair. You must be a registered PHUONG user. Pick your platform — or run both.",
      platformA: "Platform A",
      platformB: "Platform B",
      tiktokThresh: "≥ 100 views",
      fbThresh: "≥ 10 reactions",
      originality: "Originality",
      originalityV: "Your own footage. No re-uploads, stolen clips, or AI spam.",
      contentRow: "Content",
      contentRowV: "Showcase a real experience or feature of the PHUONG app.",
      threshold: "Threshold",
      thresholdV: "Must reach at least 100 views before submitting.",
      format: "Format",
      formatV: "Public video link — no private or unlisted.",
      fbFormat: "Format",
      fbFormatV: "Post must contain images or video, like a TikTok-style post.",
      placement: "Placement",
      placementV: "Personal profile or public anime-related groups.",
      engagement: "Engagement",
      engagementV: "At least 10 reactions, likes, or interactions.",
      visibility: "Visibility",
      visibilityV: "Post must be public so we can verify.",
      avgPayout: "Average payout",
      tiktokPayout: "100 – 500 BB · PRO",
      fbPayout: "100 – 200 BB",
      subMethodLabel: "Submission method",
      subMethodPre: "Submit the",
      subMethodURL: "public URL",
      subMethodMid: "of your post plus the",
      subMethodEmail: "email",
      subMethodTail: "linked to your PHUONG account.",
      submitNow: "Submit now",
    },
    rewards: {
      label: "The Payout",
      headPre: "Bluebread",
      headTail: "on the table.",
      subcopy: "No ceiling. No lottery. Performance converts directly into in-app currency and, for the best creators, full PRO Membership.",
      minDrop: "Minimum drop",
      guaranteed: "Bluebread guaranteed",
      deliveredIn: "Delivered in-app within 48 hours.",
      infoStrip: "48h · In-app mailbox · Automated",
      tierLabel: "TIER",
      tiers: [
        { label: "SPARK", note: "Baseline. Everyone who qualifies." },
        { label: "BLAZE", note: "Solid post, strong engagement." },
        { label: "INFERNO", note: "Viral on TikTok or a mega-group FB hit." },
        { label: "SUN", note: "PRO Membership unlocked. Top-tier content." },
      ],
      bluebreadUnit: "Bluebread",
      proBadge: "PRO Membership",
    },
    submit: {
      label: "The Drop",
      headPre: "Claim your",
      headTail: "Bluebread.",
      subcopy: "Submit your public post URL and the email linked to your PHUONG account. We verify within 48 hours and drop rewards straight to your in-app mailbox.",
      bullets: [
        "Public link only — not private / friends-only.",
        "Email must match your PHUONG account.",
        "One submission per post. Multiple posts welcome.",
        "Status updates land in your mailbox — no spam.",
      ],
      cardTitle: "SUBMIT_POST.EXE",
      secure: "secure · encrypted",
      platformLabel: "Platform",
      tiktokMin: "100 views",
      fbMin: "10 reactions",
      emailLabel: "PHUONG account email",
      emailPh: "you@phuong.app",
      urlLabel: "Public content link",
      agreeText: "I confirm the content is original, public, and meets the platform threshold. I agree to PHUONG's campaign terms.",
      payoutEta: "Payout ETA · 48H ·",
      payoutEtaSuffix: "in-app mailbox",
      ignite: "Ignite submission",
      transmitting: "Transmitting…",
      doneTitle: "Submission received.",
      doneDescPre: "We're verifying",
      doneDescMid: ". Bluebreads will land in the mailbox for",
      doneDescTail: "within 48 hours.",
      submitAnother: "Submit another",
      errInvalidEmail: "Please enter a valid email address.",
      errInvalidUrl: "Please enter a valid public URL (must start with http:// or https://).",
      errAgree: "Please agree to the campaign terms.",
      errCaptcha: "CAPTCHA verification failed. Please try again.",
      errGeneric: "Something went wrong. Please try again.",
      errSubmit: "Submission failed. Please try again.",
    },
    final: {
      chip: "Final call",
      h1: "Strike the match.",
      h2: "Become the sun.",
      subcopy: "Every PHUONG feed was once one post. Every immortal sun was once a matchstick. Post tonight. Earn by the weekend.",
      cta1: "Start Earning Bluebreads",
      cta2: "Read the rules",
    },
    footer: {
      copyright: "© 2026 PHUONG · Bluebread Campaign · Season 01",
      terms: "Terms",
      privacy: "Privacy",
      support: "Support",
    },
  },

  vi: {
    nav: {
      howItWorks: "Cách thức",
      rules: "Luật chơi",
      rewards: "Phần thưởng",
      submit: "Gửi bài",
    },
    hero: {
      seasonBadge: "Mùa 01 · Xuân 2026",
      rewardsLive: "Phần thưởng đang mở",
      h1Line1: "Từ một que",
      h1Matchstick: "diêm nhỏ",
      h1Line2Pre: "đến mặt trời",
      h1Immortal: "bất diệt",
      h1Line2Post: ".",
      descPre: "Thắp lửa cho nội dung của bạn. Đăng PHUONG trên TikTok hoặc các group Facebook anime, đạt ngưỡng tương tác, và chúng mình sẽ thả",
      descBluebreads: "Bluebread",
      descAnd: "— và có thể cả",
      descPro: "PRO Membership",
      descTail: "— vào hộp thư trong app trong vòng 48 giờ.",
      ctaPrimary: "Bắt đầu kiếm Bluebread",
      ctaSecondary: "Xem cách thức",
      statMin: "Bluebread tối thiểu",
      statPayout: "Thời gian trả thưởng",
      statMax: "Tiềm năng tối đa",
      bluebreadDrop: "+100 Bluebread",
    },
    how: {
      label: "Vòng lặp",
      headPre: "Năm bước từ",
      headMid: "tia lửa",
      headTail: "đến phần thưởng.",
      subcopy: "Một vòng lặp gọn gàng: chạy một lần, chạy mỗi ngày, hay chạy trong giấc ngủ. Càng đăng nhiều, mặt trời càng bất diệt.",
      steps: [
        { title: "Tạo nội dung", body: "Quay, dựng, thiết kế — video TikTok hoặc bài Facebook gốc thể hiện trải nghiệm PHUONG thật của bạn." },
        { title: "Đăng & gắn thẻ", body: "Đăng trên TikTok hoặc group Facebook anime / trang cá nhân công khai. Không repost. Không copy. Chỉ nội dung gốc." },
        { title: "Đạt ngưỡng", body: "TikTok: 100+ lượt xem. Facebook: 10+ lượt tương tác. Nội dung tốt thường vượt xa con số này ngay ngày đầu." },
        { title: "Gửi link", body: "Nhập URL công khai và email tài khoản PHUONG của bạn vào form trên trang này." },
        { title: "Nhận thưởng", body: "Trong 48h chúng mình sẽ xác minh và thả Bluebread vào hộp thư trong app. Bài hot có thể nhận PRO Membership." },
      ],
      next: "Tiếp ↓",
      done: "Xong ✓",
    },
    rules: {
      label: "Điều kiện",
      headPre: "Luật",
      headTail: "của sàn đấu.",
      subcopy: "Đơn giản, rõ ràng, công bằng. Bạn phải là người dùng PHUONG đã đăng ký. Chọn nền tảng — hoặc chơi cả hai.",
      platformA: "Nền tảng A",
      platformB: "Nền tảng B",
      tiktokThresh: "≥ 100 lượt xem",
      fbThresh: "≥ 10 tương tác",
      originality: "Tính nguyên gốc",
      originalityV: "Video của chính bạn. Không re-upload, clip trộm, hay spam AI.",
      contentRow: "Nội dung",
      contentRowV: "Thể hiện trải nghiệm hoặc tính năng thực tế của app PHUONG.",
      threshold: "Ngưỡng",
      thresholdV: "Phải đạt ít nhất 100 lượt xem trước khi gửi.",
      format: "Định dạng",
      formatV: "Link video công khai — không private, không unlisted.",
      fbFormat: "Định dạng",
      fbFormatV: "Bài đăng phải có ảnh hoặc video, theo phong cách như TikTok.",
      placement: "Vị trí đăng",
      placementV: "Trang cá nhân hoặc group Facebook liên quan đến anime công khai.",
      engagement: "Tương tác",
      engagementV: "Ít nhất 10 reaction, like, hoặc bình luận.",
      visibility: "Hiển thị",
      visibilityV: "Bài phải công khai để chúng mình có thể xác minh.",
      avgPayout: "Thưởng trung bình",
      tiktokPayout: "100 – 500 BB · PRO",
      fbPayout: "100 – 200 BB",
      subMethodLabel: "Cách gửi bài",
      subMethodPre: "Gửi",
      subMethodURL: "URL công khai",
      subMethodMid: "của bài đăng cùng với",
      subMethodEmail: "email",
      subMethodTail: "liên kết với tài khoản PHUONG của bạn.",
      submitNow: "Gửi ngay",
    },
    rewards: {
      label: "Trả thưởng",
      headPre: "Bluebread",
      headTail: "đặt trên bàn.",
      subcopy: "Không có trần. Không xổ số. Hiệu suất được quy đổi trực tiếp thành tiền trong app, và với những creator xuất sắc nhất — PRO Membership đầy đủ.",
      minDrop: "Mức tối thiểu",
      guaranteed: "Bluebread đảm bảo",
      deliveredIn: "Gửi trong app trong vòng 48 giờ.",
      infoStrip: "48h · Hộp thư trong app · Tự động",
      tierLabel: "HẠNG",
      tiers: [
        { label: "SPARK", note: "Mức nền. Ai đủ điều kiện đều nhận." },
        { label: "BLAZE", note: "Bài đăng chắc, tương tác mạnh." },
        { label: "INFERNO", note: "Viral trên TikTok hoặc bùng nổ trên group FB lớn." },
        { label: "SUN", note: "Mở khóa PRO Membership. Nội dung đỉnh cao." },
      ],
      bluebreadUnit: "Bluebread",
      proBadge: "PRO Membership",
    },
    submit: {
      label: "Nhận thưởng",
      headPre: "Nhận",
      headTail: "Bluebread của bạn.",
      subcopy: "Gửi URL bài đăng công khai cùng email liên kết tài khoản PHUONG. Chúng mình xác minh trong 48 giờ và gửi thưởng thẳng vào hộp thư trong app.",
      bullets: [
        "Chỉ link công khai — không private / chỉ bạn bè.",
        "Email phải khớp với tài khoản PHUONG của bạn.",
        "Mỗi bài một lần gửi. Đăng nhiều bài càng tốt.",
        "Cập nhật trạng thái qua hộp thư — không spam.",
      ],
      cardTitle: "SUBMIT_POST.EXE",
      secure: "bảo mật · mã hóa",
      platformLabel: "Nền tảng",
      tiktokMin: "100 lượt xem",
      fbMin: "10 tương tác",
      emailLabel: "Email tài khoản PHUONG",
      emailPh: "you@phuong.app",
      urlLabel: "Link nội dung công khai",
      agreeText: "Tôi xác nhận nội dung là nguyên gốc, công khai, và đạt ngưỡng nền tảng. Tôi đồng ý với điều khoản chiến dịch của PHUONG.",
      payoutEta: "Trả thưởng · 48H ·",
      payoutEtaSuffix: "hộp thư trong app",
      ignite: "Châm lửa gửi bài",
      transmitting: "Đang gửi…",
      doneTitle: "Đã nhận bài gửi.",
      doneDescPre: "Chúng mình đang xác minh",
      doneDescMid: ". Bluebread sẽ được gửi vào hộp thư của",
      doneDescTail: "trong vòng 48 giờ.",
      submitAnother: "Gửi bài khác",
      errInvalidEmail: "Vui lòng nhập email hợp lệ.",
      errInvalidUrl: "Vui lòng nhập URL công khai hợp lệ (bắt đầu bằng http:// hoặc https://).",
      errAgree: "Vui lòng đồng ý với điều khoản chiến dịch.",
      errCaptcha: "Xác minh CAPTCHA thất bại. Vui lòng thử lại.",
      errGeneric: "Có lỗi xảy ra. Vui lòng thử lại.",
      errSubmit: "Gửi bài thất bại. Vui lòng thử lại.",
    },
    final: {
      chip: "Lời kêu gọi cuối",
      h1: "Thắp que diêm.",
      h2: "Hóa thành mặt trời.",
      subcopy: "Mọi feed PHUONG đều từng là một bài đăng. Mọi mặt trời bất diệt đều từng là một que diêm. Đăng đêm nay. Nhận thưởng cuối tuần.",
      cta1: "Bắt đầu kiếm Bluebread",
      cta2: "Đọc luật",
    },
    footer: {
      copyright: "© 2026 PHUONG · Chiến dịch Bluebread · Mùa 01",
      terms: "Điều khoản",
      privacy: "Quyền riêng tư",
      support: "Hỗ trợ",
    },
  },

  ja: {
    nav: {
      howItWorks: "仕組み",
      rules: "ルール",
      rewards: "報酬",
      submit: "投稿",
    },
    hero: {
      seasonBadge: "シーズン01 · 2026春",
      rewardsLive: "報酬配布中",
      h1Line1: "小さな",
      h1Matchstick: "マッチ棒",
      h1Line2Pre: "から、不滅の",
      h1Immortal: "太陽",
      h1Line2Post: "へ。",
      descPre: "あなたのコンテンツに火をつけよう。TikTokやアニメ系Facebookグループで PHUONG を投稿し、エンゲージメント基準を達成すれば、",
      descBluebreads: "Bluebread",
      descAnd: "、そして",
      descPro: "PROメンバーシップ",
      descTail: "を48時間以内にアプリ内メールボックスへお届けします。",
      ctaPrimary: "Bluebreadを獲得する",
      ctaSecondary: "仕組みを見る",
      statMin: "最低Bluebread",
      statPayout: "支払いウィンドウ",
      statMax: "最大ポテンシャル",
      bluebreadDrop: "+100 Bluebread",
    },
    how: {
      label: "ループ",
      headPre: "スパークから報酬まで",
      headMid: "5ステップ",
      headTail: "。",
      subcopy: "一度でも、毎日でも、寝ながらでも回せるクリーンなループ。投稿するほど、太陽はより不滅になる。",
      steps: [
        { title: "コンテンツ制作", body: "撮影・編集・デザイン — あなたの本物のPHUONG体験を収めたオリジナルのTikTok動画やFacebook投稿を作ろう。" },
        { title: "投稿＆タグ", body: "TikTokまたはアニメ系Facebookグループ／公開プロフィールで公開。再投稿不可。ミラー不可。オリジナルのみ。" },
        { title: "基準を超える", body: "TikTok：100+ビュー。Facebook：10+リアクション。良質なコンテンツは初日で軽々超えることが多い。" },
        { title: "リンクを送信", body: "このページのフォームに公開URLとPHUONGアカウントのメールアドレスを入力。" },
        { title: "報酬を受け取る", body: "48時間以内に確認し、Bluebreadをアプリ内メールボックスへ。大ヒットはPROメンバーシップ獲得。" },
      ],
      next: "次へ ↓",
      done: "完了 ✓",
    },
    rules: {
      label: "参加資格",
      headPre: "アリーナの",
      headTail: "ルール。",
      subcopy: "シンプル、厳格、公平。PHUONG登録ユーザーであること。プラットフォームを選ぶ — 両方でもOK。",
      platformA: "プラットフォームA",
      platformB: "プラットフォームB",
      tiktokThresh: "≥ 100ビュー",
      fbThresh: "≥ 10リアクション",
      originality: "オリジナリティ",
      originalityV: "自分の映像のみ。再投稿、盗用クリップ、AIスパムは不可。",
      contentRow: "コンテンツ",
      contentRowV: "PHUONGアプリの実体験や機能を紹介すること。",
      threshold: "基準",
      thresholdV: "送信前に最低100ビューを達成すること。",
      format: "形式",
      formatV: "公開動画リンク — 非公開や限定公開は不可。",
      fbFormat: "形式",
      fbFormatV: "投稿には画像または動画が必要（TikTok風）。",
      placement: "投稿場所",
      placementV: "個人プロフィールまたは公開アニメ関連グループ。",
      engagement: "エンゲージメント",
      engagementV: "最低10リアクション、いいね、またはインタラクション。",
      visibility: "公開範囲",
      visibilityV: "確認できるよう、投稿は公開にすること。",
      avgPayout: "平均支払い",
      tiktokPayout: "100 – 500 BB · PRO",
      fbPayout: "100 – 200 BB",
      subMethodLabel: "送信方法",
      subMethodPre: "投稿の",
      subMethodURL: "公開URL",
      subMethodMid: "と、PHUONGアカウントに紐づく",
      subMethodEmail: "メールアドレス",
      subMethodTail: "を送信してください。",
      submitNow: "今すぐ送信",
    },
    rewards: {
      label: "支払い",
      headPre: "テーブルに並ぶ",
      headTail: "Bluebread。",
      subcopy: "上限なし。抽選なし。パフォーマンスがそのままアプリ内通貨に、トップクリエイターにはPROメンバーシップまで。",
      minDrop: "最低ドロップ",
      guaranteed: "Bluebread保証",
      deliveredIn: "48時間以内にアプリ内で配布。",
      infoStrip: "48h · アプリ内メールボックス · 自動",
      tierLabel: "ティア",
      tiers: [
        { label: "SPARK", note: "ベースライン。資格を満たす全員。" },
        { label: "BLAZE", note: "堅実な投稿、強いエンゲージメント。" },
        { label: "INFERNO", note: "TikTokでバイラル、または大規模FBグループでヒット。" },
        { label: "SUN", note: "PROメンバーシップ解放。トップレベルのコンテンツ。" },
      ],
      bluebreadUnit: "Bluebread",
      proBadge: "PROメンバーシップ",
    },
    submit: {
      label: "ドロップ",
      headPre: "獲得しよう、あなたの",
      headTail: "Bluebread。",
      subcopy: "公開投稿のURLとPHUONGアカウントのメールアドレスを送信。48時間以内に確認し、報酬をアプリ内メールボックスへ直接配布します。",
      bullets: [
        "公開リンクのみ — 非公開／友達限定は不可。",
        "メールアドレスはPHUONGアカウントと一致すること。",
        "1投稿につき1送信。複数投稿歓迎。",
        "ステータス更新はメールボックスへ — スパムなし。",
      ],
      cardTitle: "SUBMIT_POST.EXE",
      secure: "セキュア · 暗号化",
      platformLabel: "プラットフォーム",
      tiktokMin: "100ビュー",
      fbMin: "10リアクション",
      emailLabel: "PHUONGアカウントのメール",
      emailPh: "you@phuong.app",
      urlLabel: "公開コンテンツのリンク",
      agreeText: "コンテンツがオリジナルで公開されており、プラットフォーム基準を満たすことを確認します。PHUONGキャンペーン規約に同意します。",
      payoutEta: "支払い予定 · 48H ·",
      payoutEtaSuffix: "アプリ内メールボックス",
      ignite: "送信を点火",
      transmitting: "送信中…",
      doneTitle: "送信を受け付けました。",
      doneDescPre: "確認中：",
      doneDescMid: "。Bluebreadは次のメールボックスへ届きます：",
      doneDescTail: "48時間以内。",
      submitAnother: "別の投稿を送信",
      errInvalidEmail: "有効なメールアドレスを入力してください。",
      errInvalidUrl: "有効な公開URLを入力してください（http://またはhttps://で始まる必要があります）。",
      errAgree: "キャンペーン規約に同意してください。",
      errCaptcha: "CAPTCHA認証に失敗しました。もう一度お試しください。",
      errGeneric: "問題が発生しました。もう一度お試しください。",
      errSubmit: "送信に失敗しました。もう一度お試しください。",
    },
    final: {
      chip: "最後のコール",
      h1: "マッチを擦れ。",
      h2: "太陽になれ。",
      subcopy: "すべてのPHUONGフィードはかつて一つの投稿だった。すべての不滅の太陽はかつて一本のマッチ棒だった。今夜投稿しよう。週末には報酬が手に入る。",
      cta1: "Bluebreadを獲得する",
      cta2: "ルールを読む",
    },
    footer: {
      copyright: "© 2026 PHUONG · Bluebreadキャンペーン · シーズン01",
      terms: "利用規約",
      privacy: "プライバシー",
      support: "サポート",
    },
  },

  zh: {
    nav: {
      howItWorks: "玩法",
      rules: "规则",
      rewards: "奖励",
      submit: "提交",
    },
    hero: {
      seasonBadge: "第 01 季 · 2026 春",
      rewardsLive: "奖励发放中",
      h1Line1: "从一根小小的",
      h1Matchstick: "火柴",
      h1Line2Pre: "到一颗不朽的",
      h1Immortal: "太阳",
      h1Line2Post: "。",
      descPre: "点燃你的内容。在 TikTok 或动漫 Facebook 群组发布 PHUONG，达到互动门槛，我们将在 48 小时内把",
      descBluebreads: "Bluebread",
      descAnd: "——甚至",
      descPro: "PRO 会员",
      descTail: "——送进你的应用内邮箱。",
      ctaPrimary: "开始赚 Bluebread",
      ctaSecondary: "了解玩法",
      statMin: "最低 Bluebread",
      statPayout: "发放周期",
      statMax: "最大潜力",
      bluebreadDrop: "+100 Bluebread",
    },
    how: {
      label: "循环",
      headPre: "从火花到发放,仅需",
      headMid: "五步",
      headTail: "。",
      subcopy: "一个干净的循环,跑一次、天天跑、甚至在睡梦中跑。发得越多,太阳越不朽。",
      steps: [
        { title: "创作内容", body: "拍摄、剪辑、设计 — 原创 TikTok 视频或 Facebook 帖子,展示你真实的 PHUONG 体验。" },
        { title: "发布并加标签", body: "发布到 TikTok 或动漫 Facebook 群组 / 你的公开主页。禁止转载。禁止搬运。仅限原创。" },
        { title: "达到门槛", body: "TikTok:100+ 次观看。Facebook:10+ 次互动。优质内容往往在第一天就能轻松超过。" },
        { title: "提交链接", body: "把公开 URL 和你的 PHUONG 账户邮箱填进本页的表单。" },
        { title: "获得奖励", body: "48 小时内我们将审核,并把 Bluebread 投进你的应用内邮箱。爆款可获得 PRO 会员。" },
      ],
      next: "下一步 ↓",
      done: "完成 ✓",
    },
    rules: {
      label: "资格",
      headPre: "竞技场的",
      headTail: "规则。",
      subcopy: "简单、严格、公平。你必须是已注册的 PHUONG 用户。选一个平台 — 或两个都跑。",
      platformA: "平台 A",
      platformB: "平台 B",
      tiktokThresh: "≥ 100 次观看",
      fbThresh: "≥ 10 次互动",
      originality: "原创性",
      originalityV: "你自己的素材。禁止二次上传、盗用片段或 AI 垃圾内容。",
      contentRow: "内容",
      contentRowV: "展示 PHUONG 应用的真实体验或功能。",
      threshold: "门槛",
      thresholdV: "提交前必须达到至少 100 次观看。",
      format: "格式",
      formatV: "公开视频链接 — 不得为私密或未列出。",
      fbFormat: "格式",
      fbFormatV: "帖子必须包含图片或视频,类似 TikTok 风格。",
      placement: "发布位置",
      placementV: "个人主页或公开的动漫相关群组。",
      engagement: "互动",
      engagementV: "至少 10 次表情、点赞或互动。",
      visibility: "可见性",
      visibilityV: "帖子必须公开以便我们核实。",
      avgPayout: "平均奖励",
      tiktokPayout: "100 – 500 BB · PRO",
      fbPayout: "100 – 200 BB",
      subMethodLabel: "提交方式",
      subMethodPre: "请提交你帖子的",
      subMethodURL: "公开 URL",
      subMethodMid: ",以及与 PHUONG 账户绑定的",
      subMethodEmail: "邮箱",
      subMethodTail: "。",
      submitNow: "立即提交",
    },
    rewards: {
      label: "奖励发放",
      headPre: "Bluebread",
      headTail: "已摆上桌。",
      subcopy: "没有上限。没有抽签。表现直接转化为应用内货币,顶尖创作者还能获得完整的 PRO 会员。",
      minDrop: "最低发放",
      guaranteed: "Bluebread 保证",
      deliveredIn: "48 小时内应用内送达。",
      infoStrip: "48h · 应用内邮箱 · 自动化",
      tierLabel: "等级",
      tiers: [
        { label: "SPARK", note: "基础线。所有达标者都能拿。" },
        { label: "BLAZE", note: "稳健的帖子,互动强劲。" },
        { label: "INFERNO", note: "TikTok 上爆红,或大型 FB 群组热议。" },
        { label: "SUN", note: "解锁 PRO 会员。顶级内容。" },
      ],
      bluebreadUnit: "Bluebread",
      proBadge: "PRO 会员",
    },
    submit: {
      label: "领取",
      headPre: "领取你的",
      headTail: "Bluebread。",
      subcopy: "提交你的公开帖子 URL 和绑定 PHUONG 账户的邮箱。我们将在 48 小时内审核,并直接把奖励送进你的应用内邮箱。",
      bullets: [
        "仅限公开链接 — 不得为私密 / 仅好友可见。",
        "邮箱必须与 PHUONG 账户一致。",
        "每条帖子提交一次。欢迎多条提交。",
        "状态更新发至邮箱 — 无垃圾信息。",
      ],
      cardTitle: "SUBMIT_POST.EXE",
      secure: "安全 · 加密",
      platformLabel: "平台",
      tiktokMin: "100 次观看",
      fbMin: "10 次互动",
      emailLabel: "PHUONG 账户邮箱",
      emailPh: "you@phuong.app",
      urlLabel: "公开内容链接",
      agreeText: "我确认该内容为原创、公开,并满足平台门槛。我同意 PHUONG 的活动条款。",
      payoutEta: "预计发放 · 48H ·",
      payoutEtaSuffix: "应用内邮箱",
      ignite: "点燃提交",
      transmitting: "传输中…",
      doneTitle: "已收到提交。",
      doneDescPre: "我们正在核实",
      doneDescMid: "。Bluebread 将发送至邮箱:",
      doneDescTail: "48 小时内送达。",
      submitAnother: "再提交一条",
      errInvalidEmail: "请输入有效的邮箱地址。",
      errInvalidUrl: "请输入有效的公开 URL(必须以 http:// 或 https:// 开头)。",
      errAgree: "请同意活动条款。",
      errCaptcha: "CAPTCHA 验证失败。请重试。",
      errGeneric: "出现问题。请重试。",
      errSubmit: "提交失败。请重试。",
    },
    final: {
      chip: "最后召集",
      h1: "擦亮火柴。",
      h2: "化作太阳。",
      subcopy: "每一个 PHUONG 信息流都曾是一条帖子。每一颗不朽的太阳都曾是一根火柴。今晚就发。周末就收。",
      cta1: "开始赚 Bluebread",
      cta2: "阅读规则",
    },
    footer: {
      copyright: "© 2026 PHUONG · Bluebread 活动 · 第 01 季",
      terms: "条款",
      privacy: "隐私",
      support: "支持",
    },
  },

  ko: {
    nav: {
      howItWorks: "진행 방식",
      rules: "규칙",
      rewards: "보상",
      submit: "제출",
    },
    hero: {
      seasonBadge: "시즌 01 · 2026 봄",
      rewardsLive: "보상 지급 중",
      h1Line1: "작은",
      h1Matchstick: "성냥개비",
      h1Line2Pre: "에서 불멸의",
      h1Immortal: "태양",
      h1Line2Post: "까지.",
      descPre: "콘텐츠에 불을 붙이세요. TikTok이나 애니메이션 Facebook 그룹에 PHUONG을 게시하고 참여 기준을 달성하면, 48시간 내에",
      descBluebreads: "Bluebread",
      descAnd: " — 그리고 경우에 따라",
      descPro: "PRO 멤버십",
      descTail: "을 앱 내 메일함으로 보내드립니다.",
      ctaPrimary: "Bluebread 획득 시작",
      ctaSecondary: "진행 방식",
      statMin: "최소 Bluebread",
      statPayout: "지급 기간",
      statMax: "최대 잠재력",
      bluebreadDrop: "+100 Bluebread",
    },
    how: {
      label: "루프",
      headPre: "불꽃에서 지급까지",
      headMid: "다섯 단계",
      headTail: ".",
      subcopy: "한 번 돌려도, 매일 돌려도, 자면서 돌려도 되는 깔끔한 루프. 많이 게시할수록 태양은 더 불멸에 가까워집니다.",
      steps: [
        { title: "콘텐츠 제작", body: "촬영, 편집, 디자인 — 당신의 진짜 PHUONG 경험을 담은 오리지널 TikTok 영상이나 Facebook 게시물을 만드세요." },
        { title: "게시 및 태그", body: "TikTok 또는 애니메이션 Facebook 그룹 / 공개 프로필에 게시. 재게시 금지. 미러 금지. 오리지널만." },
        { title: "기준 달성", body: "TikTok: 100+ 조회. Facebook: 10+ 리액션. 좋은 콘텐츠는 보통 첫날에 이를 가볍게 넘깁니다." },
        { title: "링크 제출", body: "이 페이지의 양식에 공개 URL과 PHUONG 계정 이메일을 입력하세요." },
        { title: "보상 수령", body: "48시간 내에 확인 후 Bluebread를 앱 내 메일함으로 보내드립니다. 대박은 PRO 멤버십을 받습니다." },
      ],
      next: "다음 ↓",
      done: "완료 ✓",
    },
    rules: {
      label: "자격",
      headPre: "경기장의",
      headTail: "규칙.",
      subcopy: "심플하고, 엄격하고, 공정합니다. PHUONG 등록 사용자여야 합니다. 플랫폼을 선택하세요 — 둘 다도 가능.",
      platformA: "플랫폼 A",
      platformB: "플랫폼 B",
      tiktokThresh: "≥ 100 조회",
      fbThresh: "≥ 10 리액션",
      originality: "오리지널리티",
      originalityV: "본인 영상만. 재업로드, 도용 클립, AI 스팸 금지.",
      contentRow: "콘텐츠",
      contentRowV: "PHUONG 앱의 실제 경험이나 기능을 보여주세요.",
      threshold: "기준",
      thresholdV: "제출 전 최소 100 조회를 달성해야 합니다.",
      format: "형식",
      formatV: "공개 영상 링크 — 비공개나 일부 공개 불가.",
      fbFormat: "형식",
      fbFormatV: "게시물에는 이미지나 영상이 포함되어야 합니다(TikTok 스타일).",
      placement: "게시 위치",
      placementV: "개인 프로필 또는 공개 애니메이션 관련 그룹.",
      engagement: "참여",
      engagementV: "최소 10개의 리액션, 좋아요 또는 상호작용.",
      visibility: "공개 설정",
      visibilityV: "확인할 수 있도록 게시물은 공개여야 합니다.",
      avgPayout: "평균 지급액",
      tiktokPayout: "100 – 500 BB · PRO",
      fbPayout: "100 – 200 BB",
      subMethodLabel: "제출 방법",
      subMethodPre: "게시물의",
      subMethodURL: "공개 URL",
      subMethodMid: "과 PHUONG 계정에 연결된",
      subMethodEmail: "이메일",
      subMethodTail: "을 제출하세요.",
      submitNow: "지금 제출",
    },
    rewards: {
      label: "지급",
      headPre: "테이블 위의",
      headTail: "Bluebread.",
      subcopy: "상한 없음. 추첨 없음. 성과가 바로 앱 내 재화로 전환되며, 최고의 크리에이터에게는 PRO 멤버십 전체가 주어집니다.",
      minDrop: "최소 지급",
      guaranteed: "Bluebread 보장",
      deliveredIn: "48시간 내 앱 내 전달.",
      infoStrip: "48h · 앱 내 메일함 · 자동",
      tierLabel: "티어",
      tiers: [
        { label: "SPARK", note: "기본선. 자격을 충족한 모두." },
        { label: "BLAZE", note: "탄탄한 게시물, 강한 참여." },
        { label: "INFERNO", note: "TikTok에서 바이럴 또는 대형 FB 그룹 히트." },
        { label: "SUN", note: "PRO 멤버십 잠금 해제. 최상위 콘텐츠." },
      ],
      bluebreadUnit: "Bluebread",
      proBadge: "PRO 멤버십",
    },
    submit: {
      label: "드롭",
      headPre: "받으세요, 당신의",
      headTail: "Bluebread.",
      subcopy: "공개 게시물 URL과 PHUONG 계정에 연결된 이메일을 제출하세요. 48시간 내에 확인하고 보상을 앱 내 메일함으로 바로 보내드립니다.",
      bullets: [
        "공개 링크만 — 비공개 / 친구 공개 불가.",
        "이메일은 PHUONG 계정과 일치해야 합니다.",
        "게시물당 한 번 제출. 여러 게시물 환영.",
        "상태 업데이트는 메일함으로 — 스팸 없음.",
      ],
      cardTitle: "SUBMIT_POST.EXE",
      secure: "보안 · 암호화",
      platformLabel: "플랫폼",
      tiktokMin: "100 조회",
      fbMin: "10 리액션",
      emailLabel: "PHUONG 계정 이메일",
      emailPh: "you@phuong.app",
      urlLabel: "공개 콘텐츠 링크",
      agreeText: "콘텐츠가 오리지널이며 공개되어 있고 플랫폼 기준을 충족함을 확인합니다. PHUONG 캠페인 약관에 동의합니다.",
      payoutEta: "지급 예정 · 48H ·",
      payoutEtaSuffix: "앱 내 메일함",
      ignite: "전송 점화",
      transmitting: "전송 중…",
      doneTitle: "제출이 접수되었습니다.",
      doneDescPre: "확인 중:",
      doneDescMid: ". Bluebread는 다음 메일함으로 전송됩니다:",
      doneDescTail: "48시간 내.",
      submitAnother: "다른 게시물 제출",
      errInvalidEmail: "유효한 이메일 주소를 입력해주세요.",
      errInvalidUrl: "유효한 공개 URL을 입력해주세요 (http:// 또는 https://로 시작).",
      errAgree: "캠페인 약관에 동의해주세요.",
      errCaptcha: "CAPTCHA 인증에 실패했습니다. 다시 시도해주세요.",
      errGeneric: "문제가 발생했습니다. 다시 시도해주세요.",
      errSubmit: "제출에 실패했습니다. 다시 시도해주세요.",
    },
    final: {
      chip: "마지막 콜",
      h1: "성냥을 그어라.",
      h2: "태양이 되어라.",
      subcopy: "모든 PHUONG 피드는 한때 하나의 게시물이었습니다. 모든 불멸의 태양은 한때 한 개의 성냥개비였습니다. 오늘 밤 게시하세요. 주말에 보상을 받으세요.",
      cta1: "Bluebread 획득 시작",
      cta2: "규칙 읽기",
    },
    footer: {
      copyright: "© 2026 PHUONG · Bluebread 캠페인 · 시즌 01",
      terms: "이용약관",
      privacy: "개인정보",
      support: "지원",
    },
  },
};
